export default __webpack_public_path__ + "static/toolbar-dark-c207b7f6cb253e37c7572fbe6f12b3ab.mp4";